import { accountAdd, accountDelete, accountEdit, accountGenaccno } from 'src/store/account'
import { translateLKMessage } from './helpers'

export const gridStyle = { paddingRight: 5 }
export const ACCOUNT_FORM_MODAL = 'AccountFormModal'
export const CLIENT_SEARCH_NAME = 'AccountFormClientSearch'
export const CLIENT_CONFIRM_MODAL = 'AccountFormClientConfirmModal'

export const ERR_REQUIRED_FIELD = translateLKMessage('ERR_REQUIRED_FIELD')
export const CLIENT_ADD = 'ClientAddFromAccountForm'
export const CLIENT_GROUP = 3
export const IBAN_MAX_LENGTH = 22

export const AccountActionsMethods = Object.freeze({
  add: accountAdd,
  edit: accountEdit,
  delete: accountDelete,
  genaccno: accountGenaccno,
})
